import { Button, FC, Link, Outlet} from 'external/react'

import useAuth from 'context/auth-context/hook'
import IconProfile from 'components/IconProfile'

import ParentMenu from 'layout/Menus/ParentMenu'
import { withContext } from 'context/index'

const ParentLayout: FC = () => {

	const {user} = useAuth()
	
	return (
		<>
			<div className='navbar navbar-light navbar-expand justify-content-between bg-white shadow header--navbar sticky-top'>
			<span className='navbar-brand'>
				<Link to={'/home'} className='navbar-brand fw-bold' style={{ color: '#42C3DB' }} >
					EduSystem
				</Link>
			</span>
			<div className='navbar-collapse principal-menu' style={{justifyContent: 'flex-end'}} id='navbar-collapse'>
					<ul className='nav navbar-nav ml-auto'>
						<div className='navbar-text mr-3'>
							<span className='fw-bold align-middle'>Dominio:</span>
							<span className='align-middle pl-2'>{user.domain}</span>
						</div>
						<ParentMenu />
						<li className='nav-item mr-4'>
							<Button className='btn btn-purple ml-1' href='/offers'>Comprar</Button>
						</li>
						<IconProfile/>
					</ul>
				</div>
			</div>
			<Outlet />
		</>
	)
}

export default withContext(ParentLayout, 'parent')
